import React from 'react';
import { FiMaximize2 } from 'react-icons/fi';

const HomeQRButton = ({ action, title, subtitle }) => {
    return (
        <div className="cardItem">
            <div
                className="cardItemButton"
                onClick={action}
                data-bs-target="#modalQR"
                data-bs-toggle="modal"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        action();
                    }
                }}
            >
                <div className="cardTextContainer">
                    <div className="home-card-icon-wrap" aria-hidden>
                        <FiMaximize2 size={22} />
                    </div>
                    <p className="cardTitle mb-0">{title}</p>
                    <p className="cardSubtitle mb-0">{subtitle}</p>
                </div>
            </div>
        </div>
    );
};

export default HomeQRButton;
